var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Header"},[_c('Logo'),_c('ToggleButton',{ref:"toggle",attrs:{"text":'Spielleiter-Ansicht'},on:{"toggle":_vm.switchView}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }